import PropTypes from 'prop-types';
import { ToggleButton } from '@bwoty-web/ui-kit';

import './filterButtonGroup.scss';

const FilterButtonGroup = ({
  allBtnTotalNumberOfItems = null,
  filterActions,
  filterGroupId,
  filterMatches,
  filterStopsAllLabel,
  handleSelect,
  options,
  selectedValues,
}) => {
  return (
    <div className="iw-filter__buttons">
      <ToggleButton
        key={`${filterGroupId}-all`}
        checked={!selectedValues.length}
        onChange={() => filterActions.clearSingleFilter(filterGroupId)}
      >
        {`${filterStopsAllLabel} (${allBtnTotalNumberOfItems || filterMatches[filterGroupId].all})`}
      </ToggleButton>
      {options.map((option) => (
        <ToggleButton
          key={option.id}
          checked={selectedValues.includes(option.id)}
          onChange={() => handleSelect(option.id)}
          disabled={filterMatches[filterGroupId][option.id] === 0}
        >
          {option.name}
          {` (${filterMatches[filterGroupId][option.id]})`}
        </ToggleButton>
      ))}
    </div>
  );
};

FilterButtonGroup.propTypes = {
  allBtnTotalNumberOfItems: PropTypes.number,
  filterActions: PropTypes.shape({
    clearSingleFilter: PropTypes.func.isRequired,
  }).isRequired,
  filterGroupId: PropTypes.string.isRequired,
  filterMatches: PropTypes.shape({}).isRequired,
  filterStopsAllLabel: PropTypes.string.isRequired,
  handleSelect: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  // Option ids, not labels: numbers for the stops, carrier and airport groups, strings for
  // luggage. `selectedValues.includes(option.id)` above compares against them directly, so both
  // types are real and the narrower `arrayOf(string)` this used to declare warned on every
  // numeric selection.
  selectedValues: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
};

export default FilterButtonGroup;
